var map = {
	"./ActionsModal/Cambio.vue": 810,
	"./ActionsModal/SaveChanges.vue": 811,
	"./ActionsModal/index.vue": 247,
	"./agrocolor.vue": 2082,
	"./araporcei.vue": 2083,
	"./coplaca/ParcelasActionsMultiple.vue": 1140,
	"./coplaca/index.vue": 2084,
	"./default.vue": 2085,
	"./demo.vue": 2086,
	"./sites.vue": 308,
	"./widgets/auditorias.vue": 812,
	"./widgets/dictamenes.vue": 815,
	"./widgets/pacs.vue": 817,
	"./widgets/revisiones.vue": 814,
	"./widgets/solicitudes.vue": 813,
	"./widgets/toma_muestras.vue": 816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1793;